'use client'

import { navigateToPage } from '@marketplace-web/shared/browser-util'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { clickEvent, VasEntryPointModel, VasEntryPoint } from '@marketplace-web/vas/vas-data'

import VasBanner from '../VasBanner/VasBanner'
import { CLOSET_PROMOTION_STATS_URL } from '../../../constants/routes'
import { VasImages } from '../../../constants/vas-entry-point'

type Props = {
  promotedClosetsBanner?: VasEntryPointModel
  handlePrecheckoutOpen: () => void
}

const ClosetPromotionBanner = ({ promotedClosetsBanner, handlePrecheckoutOpen }: Props) => {
  const { track } = useTracking()

  if (!promotedClosetsBanner) return null

  const isClosetPromoted = promotedClosetsBanner.name === VasEntryPoint.PromotedClosetsStats

  const handleClosetPromotionBannerClick = () => {
    if (isClosetPromoted) navigateToPage(CLOSET_PROMOTION_STATS_URL)

    if (!isClosetPromoted) {
      handlePrecheckoutOpen()

      track(
        clickEvent({
          screen: 'current_user_profile',
          target: 'promote_closet',
        }),
      )
    }
  }

  const bannerProps = {
    ...promotedClosetsBanner,
    onClick: handleClosetPromotionBannerClick,
    testId: isClosetPromoted ? 'cp-stats-banner' : 'cp-banner',
    icon: isClosetPromoted ? VasImages.VasClosetPromoStats : VasImages.VasClosetPromo,
  }

  return <VasBanner {...bannerProps} />
}

export default ClosetPromotionBanner
